export default __webpack_public_path__ + "static/media/289.2ea1a3a8.jpg";